// import React, { useEffect, useState } from "react";
// import Cookies from "universal-cookie";
// import { Community, apiConfig } from "../config";
// import HomepageHeader from "../Component/HomepageHeader";
// import ProfessionalHeader from "../Professionals/ProfessionalHeader";
// import DashboardHeader from "../Component/DashboardHeader";
// import Footer from "../Component/Footer";
// import FooterBlackStrip from "../Component/FooterBlackStrip";
// import FooterHome from "../Component/FooterHome";
// import FooterHomeStripe from "../Component/FooterHomeStripe";
// import axios from "axios";
// import { RotatingLines } from "react-loader-spinner";
// import { DecodingString } from "../helperFunction/DecodingString";
// import moment from "moment";
// import back from "../recommended activites/images/Vector2.png";
// import { useNavigate } from "react-router-dom";

// const AllHappinessNews = () => {
//   const [news, setNews] = useState([]);
//   const [loader, setLoader] = useState(true);
//   const cookies = new Cookies();
//   const roleType = DecodingString(cookies.get("_ssUuId", { path: "/" }));
//   const isLoggedIn = cookies.get("isLoggedIn", { path: "/" });
//   const navigate = useNavigate();
//   // 🔗 The URL you want to embed (replace with actual news source)
//   const iframeUrl =
//     "https://akshaygupta649.lpages.co/bit-happier-landing-page/";

//   const handleIframeLoad = () => {
//     setLoader(false);
//   };

//   return (
//     <main style={{ flexGrow: 1, position: "relative" }}>
//       {loader && (
//         <div
//           className="d-flex justify-content-center align-items-center"
//           style={{
//             position: "absolute",
//             inset: 0,
//             background: "#fff", // or transparent if you want overlay
//             zIndex: 10,
//           }}
//         >
//           <RotatingLines
//             strokeColor="#7637fd"
//             strokeWidth="5"
//             animationDuration="0.75"
//             width="96"
//             visible={true}
//           />
//         </div>
//       )}

//       <iframe
//         src={iframeUrl}
//         title="Happiness News Feed"
//         style={{
//           width: "100%",
//           height: "100vh",
//           border: "none",
//           display: "block",
//         }}
//         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//         onLoad={handleIframeLoad}
//       />
//     </main>
//   );
// };

// export default AllHappinessNews;
import logo from "../images/bitlogoimg.svg";
import heroLogo from "../images/HeroLogo.png";
import card1 from "../images/cardOne.png";
import card2 from "../images/cardSecond.png";
import card3 from "../images/cardThird.png";
import group from "../images/groupNew.png";
import lotus from "../images/lotusLogoNew.png";
import certificate from "../images/certificateNew.png";
import beata from "../images/beata.png";
import rajnish from "../images/rajeshwari.png";
import lastSection from "../images/lastSection.png";
import spotifyLink from "../images/spotifyLink.png";
import { FaXTwitter, FaLinkedinIn, FaInstagram, FaYoutube, FaTiktok } from 'react-icons/fa6';
import './MeetupsCard.css'
import back from '../images/vector2Gem.svg'
import { useState } from 'react';
import axios from 'axios';
import { APIURI } from '../config';



import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
const MeetUp = () => {
  const navigate = useNavigate()
  const [events, setEvents] = useState([])
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLocationExpanded, setIsLocationExpanded] = useState(false);

  useEffect(() => {
    axios
      .get(
        `${APIURI}api/v2/user/happiness/meetups/list/0?pageSize=80&categoryId=&country=&city=`).then((res) => {
          console.log(res.data);
          setEvents(res.data.data);
        })
  }, [])

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const toggleLocationExpand = () => {
    setIsLocationExpanded(!isLocationExpanded);
  };

  // Function to format time from 24-hour to AM/PM format
  const formatTime = (timeStr) => {
    const time = new Date(`2000-01-01T${timeStr}:00`);
    return time.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <>
      <div className="backButtonMeetup ml-3">
        <span
          onClick={() => {
            navigate(-1);
          }}
          style={{ cursor: "pointer" }}
          className=""
        >
          <span
            style={{
              fontFamily: "Inter",
              fontWeight: "700",
              fontSize: "18px",
              color: "#201f24",
            }}
          >
            <img className="me-1" src={back} alt="" width={20} />
            Back
          </span>
        </span>
      </div>
      {/* Hero Section */}
      <div style={{
        marginTop: '3rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingInline: '1rem',
        paddingBottom: '3rem',
        gap: '2rem'
      }}
        className="hero-section">
        <div className="d-flex gap-3" style={{ width: '100%', flexDirection: 'column' }}>
          <div style={{ height: '50px', marginBottom: '1rem' }}>
            <img style={{ height: '50px' }} src={logo} alt="Logo" />
          </div>
          <button className="science-tag" style={{ width: 'fit-content' }}>NEUROSCIENCE-BACKED HAPPINESS</button>
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            color: '#201f24',
            width: '100%',
            marginTop: '2rem'
          }}>
            Let's Make Each Day a Bit Happier
          </h1>
          <p style={{ fontSize: 'clamp(1rem, 2vw, 1.25rem)', width: '100%', color: '#201f24' }}>
            Join our exclusive events designed to reduce stress, boost well-being, and build real connections. Led by our neuroscience and well-being experts, we offer practical tools for a happier life.
          </p>
          {/*  <button
            style={{
              backgroundColor: '#a98be4',
              color: '#fff',
              borderRadius: '8px',
              padding: '12px',
              width: '100%',
              maxWidth: '250px',
              border: 'none'
            }}
            onClick={() => window.open('https://luma.com/ppp0sgi3')}
          >
            Join Our Next Event
          </button> */}
        </div>
        <div className="d-flex" style={{ width: '100%', justifyContent: 'center' }}>
          <img style={{ width: '100%', maxWidth: '600px', height: 'auto' }} src={heroLogo} alt="Hero" />
        </div>
      </div>

      {/* show events  */}
      {
        events.length > 0 && (
          <div style={{
            marginTop: '3rem',
            marginBottom: '3rem',
            paddingInline: '1rem'
          }}>
            {/* <h2 style={{
              fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
              fontWeight: '700',
              color: '#0c4e7e',
              marginBottom: '2rem',
              textAlign: 'center'
            }}>
              Upcoming Events
            </h2> */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
              <button style={{
                borderRadius: '10000px',
                backgroundColor: '#a98be4',
                border: 'none',
                padding: '12px 24px',
                color: '#fff',
                fontSize: 'clamp(0.75rem, 2vw, 1rem)'
              }}>
                Upcoming Events
              </button>
            </div>
            <div className="container-fluid">
              <div className="row g-3">
                {events.map((event) => (
                  <div key={event.id} className="col-12 col-sm-6 col-md-4 col-lg-3">
                    <div className="card border-0 shadow-sm event-card-border-purple" style={{
                      borderRadius: '12px',
                      overflow: 'hidden',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      height: 'auto'
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                      }}>
                      {/* Event Image */}
                      <div style={{
                        width: '100%',
                        height: '140px',
                        overflow: 'hidden',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '12px 12px 0 0',
                      }}>
                        <img
                          src={event.imageUrl}
                          alt={event.eventName}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '12px 12px 0 0',
                          }}
                        />
                      </div>

                      {/* Event Details */}
                      <div className="card-body p-2" style={{ backgroundColor: '#fff', fontSize: '0.85rem' }}>
                        {/* Event Name */}
                        <h5 style={{
                          color: '#0c4e7e',
                          fontWeight: '600',
                          fontSize: '0.95rem',
                          marginBottom: '0.4rem',
                          // minHeight: '2.2rem',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          lineHeight: '1.1'
                        }}>
                          {event.eventName}
                        </h5>

                        {/* Category Badge */}
                        {event.categoryReqDTO && (
                          <span style={{
                            display: 'inline-block',
                            backgroundColor: '#e8e1f5',
                            color: '#5934a0',
                            padding: '2px 8px',
                            borderRadius: '12px',
                            fontSize: '0.7rem',
                            fontWeight: '500',
                            marginBottom: '0.4rem'
                          }}>
                            {event.categoryReqDTO.name}
                          </span>
                        )}

                        {/* Date & Time - Compact */}
                        <div style={{
                          fontSize: '0.8rem',
                          color: '#495057',
                          marginBottom: '0.3rem'
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', marginBottom: '0.15rem' }}>
                            <span style={{ fontSize: '0.85rem' }}>📅</span>
                            <span>{event.startDate}</span>
                            <span style={{ fontSize: '0.85rem' }}>🕐</span>
                            <span>{formatTime(event.startTime)}</span>
                          </div>
                        </div>

                        {/* Location - Compact */}
                        <div style={{
                          fontSize: '0.8rem',
                          color: '#495057',
                          marginBottom: '0.4rem',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.3rem'
                        }}>
                          <span style={{ fontSize: '0.85rem' }}>📍</span>
                          <span style={{
                            flex: 1,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}>
                            {event.city && event.country
                              ? `${event.city}, ${event.country}`
                              : event.venueLocation || 'Location TBA'
                            }
                          </span>
                        </div>

                        {/* View Details Button */}
                        <a
                          href={event.eventUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none' }}
                        >
                          <button style={{
                            width: '100%',
                            backgroundColor: '#a98be4',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '6px 12px',
                            fontSize: '0.8rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.3rem'
                          }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#8b6ec7';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#a98be4';
                            }}>
                            View Details
                            <span style={{ fontSize: '0.75rem' }}>🔗</span>
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )
      }

      {/* Features Section */}
      <div style={{
        marginTop: '3rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingInline: '1rem',
        backgroundColor: '#ffe6eb',
        paddingTop: '4rem',
        paddingBottom: '4rem'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center', marginBottom: '2rem' }}>
          <h6 style={{
            borderRadius: '10000px',
            padding: '12px 24px',
            color: '#7c5a8f',
            backgroundColor: '#fff5f7',
            border: 'none',
            textAlign: 'center',
            fontSize: 'clamp(0.875rem, 2vw, 1rem)'
          }}>
            OUR FEATURES
          </h6>
          <h3 style={{
            marginTop: '0rem',
            fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
            textAlign: 'center',
            paddingInline: '1rem',
            color: '#201f24'
          }}>
            Small Steps Toward a Happier You
          </h3>
        </div>
        <div className="d-flex justify-content-center flex-wrap" style={{ width: '100%', maxWidth: '1200px', gap: '2rem' }}>
          {/* Card 1 - Attend Happiness Meetings */}
          <div className="d-flex" style={{ flex: '1', minWidth: '300px', maxWidth: '380px' }}>
            <div className="card-meetup h-100 border-0 p-md-0 shadow-sm" style={{ borderRadius: '20px', transition: 'none' }}>
              <div className="card-body p-4 text-center d-flex flex-column">
                <div className="mb-3">
                  <img
                    src={group}
                    alt="Group"
                    style={{
                      height: '80px',
                      width: '80px',
                      objectFit: 'contain',
                      margin: '0 auto'
                    }}
                  />
                </div>
                <h3 className="card-title mb-3" style={{
                  fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                  fontWeight: 'bold',
                  color: '#4a3f42',
                  transition: 'none',
                  WebkitTextFillColor: 'currentColor'
                }}>
                  Attend Happiness Meetings
                </h3>
                <p className="card-text mb-4" style={{ fontSize: 'clamp(0.875rem, 2vw, 1rem)', color: '#6f6b6c' }}>
                  Engage with a community that shares your goals, exchange positive habits,
                  discover science-backed strategies to boost your well-being and build more{' '}
                  <span style={{ fontWeight: '700' }}>meaningful connections</span>.
                </p>
                <div className="mt-auto mb-0">
                  <div
                    style={{
                      width: '100%',
                      height: '200px',
                      display: 'flex',
                      borderRadius: '10px',
                      backgroundColor: '#F4F2F8',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden'
                    }}
                  >
                    <img
                      src={card1}
                      alt="Happiness Meeting"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        objectPosition: 'center',
                        padding: '8px',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 - Understand Your Happiness */}
          <div className="d-flex" style={{ flex: '1', minWidth: '300px', maxWidth: '380px' }}>
            <div className="card-meetup h-100 border-0 p-md-0 shadow-sm" style={{ borderRadius: '20px', transition: 'none' }}>
              <div className="card-body p-4 text-center d-flex flex-column">
                <div className="mb-3">
                  <img
                    src={lotus}
                    alt="Lotus"
                    style={{
                      height: '80px',
                      width: '80px',
                      objectFit: 'contain',
                      margin: '0 auto'
                    }}
                  />
                </div>
                <h3 className="card-title mb-3" style={{
                  fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                  fontWeight: 'bold',
                  color: '#4a3f42',
                  transition: 'none',
                  WebkitTextFillColor: 'currentColor'
                }}>
                  Understand Your Happiness
                </h3>
                <p className="card-text  mb-4" style={{
                  fontSize: 'clamp(0.875rem, 2vw, 1rem)', color: '#6f6b6c'
                }}>
                  Get a personalized{' '}
                  <span style={{ fontWeight: '700' }}>Happiness Profile</span>{' '}
                  and track your{' '}
                  <span style={{ fontWeight: '700' }}>emotional well-being</span>{' '}
                  over time with insights on stress, health, fitness, and social wellness.
                </p>
                <div className="mt-auto mb-0">
                  <div
                    style={{
                      width: '100%',
                      height: '200px',
                      borderRadius: '10px',
                      backgroundColor: '#F4F2F8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden'
                    }}
                  >
                    <img
                      src={card2}
                      alt="Happiness Profile"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        objectPosition: 'center',
                        padding: '8px'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Card 3 - Turn Happiness Into Rewards */}
          <div className="d-flex" style={{ flex: '1', minWidth: '300px', maxWidth: '380px' }}>
            <div className="card-meetup h-100 border-0 p-md-0 shadow-sm" style={{ borderRadius: '20px', transition: 'none' }}>
              <div className="card-body p-4 text-center d-flex flex-column">
                <div className="mb-3">
                  <img
                    src={certificate}
                    alt="Certificate"
                    style={{
                      height: '80px',
                      width: '80px',
                      objectFit: 'contain',
                      margin: '0 auto'
                    }}
                  />
                </div>
                <h3 className="card-title mb-3" style={{
                  fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                  fontWeight: 'bold',
                  color: '#4a3f42',
                  transition: 'none',
                  WebkitTextFillColor: 'currentColor'
                }}>
                  Turn Happiness Into Rewards
                </h3>
                <p className="card-text  mb-4" style={{ fontSize: 'clamp(0.875rem, 2vw, 1rem)', color: '#6f6b6c' }}>
                  Earn <span style={{ fontWeight: '700' }}>Bit Happier Points (BHP)</span>{' '}
                  for engaging in well-being activities, learn mindful spending habits, and use
                  your Happiness Wallet to track and redeem exclusive rewards, and even book
                  free therapy sessions.
                </p>
                <div className="mt-auto mb-0">
                  <div
                    style={{
                      width: '100%',
                      height: '200px',
                      borderRadius: '10px',
                      backgroundColor: '#F4F2F8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden'
                    }}
                  >
                    <img
                      src={card3}
                      alt="Rewards"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        objectPosition: 'center',
                        padding: '8px'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '1rem',
          marginTop: '3rem',
          paddingInline: '1rem'
        }}>
          <button
            className="hv2-btn hv2-btn-primary hv2-btn-md"
            style={{ textWrap: 'auto' }}
            onClick={() => window.open('https://bithappier-newsletter.beehiiv.com/')}>
            Sign Up To Our Newsletter to Know More About Happiness
          </button>
        </div>
      </div>

      {/* Why Bit Happier Section */}
      <div style={{
        marginTop: '3rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingInline: '1rem',
        paddingBottom: '3rem',
        paddingTop: '3rem',
        gap: '2rem'
      }}
        className="why-section">
        <div className="d-flex gap-3" style={{ width: '100%', flexDirection: 'column' }}>
          <div style={{ height: '50px', marginBottom: '1rem' }}>
            <button style={{
              borderRadius: '10000px',
              backgroundColor: '#e8ddf0',
              border: 'none',
              padding: '12px 24px',
              color: '#7c5a8f',
              fontSize: 'clamp(0.75rem, 2vw, 1rem)'
            }}>
              WHY BIT HAPPIER
            </button>
          </div>
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            color: '#0e2a36',
            width: '100%',
            marginTop: '0rem'
          }}>
            Unlock a Happier Mind and Life
          </h1>

          <div style={{
            width: '100%',
            position: 'relative',
            paddingBottom: '56.25%',
            height: '0',
            overflow: 'hidden'
          }}>
            <iframe
              src="https://www.youtube.com/embed/Taf5aX-4hj4"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%'
              }}
            />
          </div>
        </div>
        <div className="d-flex" style={{ width: '100%' }}>
          <div className="row g-4" style={{ width: '100%', gap: '20px' }}>
            {/* Card 1 - Science Meets Community */}
            <div className="col-12">
              <div
                className=" border-0 p-1"
                style={{
                  backgroundColor: '#ffe6eb',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  maxWidth: '800px',
                  margin: '0 auto',
                  height: 'fit-content !important'
                }}
              >
                <div className=" p-3 p-md-4" style={{ backgroundColor: '#ffe6eb', height: 'fit-content !important' }}>
                  <h2
                    className="card-title mb-3"
                    style={{
                      fontSize: 'clamp(1.25rem, 3vw, 1.75rem)',
                      fontWeight: 'normal',
                      color: '#201f24'
                    }}
                  >
                    Science Meets Community
                  </h2>
                  <p
                    className="card-text mb-0"
                    style={{
                      fontSize: 'clamp(0.875rem, 2vw, 1rem)',
                      lineHeight: '1.6',
                      color: '#1a1a1a'
                    }}
                  >
                    Bit Happier events bring together neuroscience experts and a supportive community. Each event combines hands-on activities and insights to deepen your understanding of happiness and strengthen your emotional and social well-being.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 - More Than Just Tracking */}
            <div className="col-12">
              <div
                className=" border-0 p-1"
                style={{
                  backgroundColor: '#ffe6eb',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  maxWidth: '800px',
                  margin: '0 auto'
                }}
              >
                <div className=" p-3 p-md-4" style={{ backgroundColor: '#ffe6eb' }}>
                  <h2
                    className="card-title mb-3"
                    style={{
                      fontSize: 'clamp(1.25rem, 3vw, 1.75rem)',
                      fontWeight: 'normal',
                      color: '#201f24'
                    }}
                  >
                    More Than Tracking — It’s Transformation
                  </h2>
                  <p
                    className="card-text mb-0"
                    style={{
                      fontSize: 'clamp(0.875rem, 2vw, 1rem)',
                      lineHeight: '1.6',
                      color: '#1a1a1a'
                    }}
                  >
                    With tools like the Happiness Score, Stress Test, and QEEG Brain Mapping, Bit Happier helps you understand what affects your well-being and provides actionable steps to improve it.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 - Happiness That Grows With You */}
            <div className="col-12">
              <div
                className=" border-0 p-1"
                style={{
                  backgroundColor: '#ffe6eb',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  maxWidth: '800px',
                  margin: '0 auto'
                }}
              >
                <div className=" p-3 p-md-4" style={{ backgroundColor: '#ffe6eb' }}>
                  <h2
                    className="card-title mb-3"
                    style={{
                      fontSize: 'clamp(1.25rem, 3vw, 1.75rem)',
                      fontWeight: 'normal',
                      color: '#201f24'
                    }}
                  >
                    Happiness That Grows With You
                  </h2>
                  <p
                    className="card-text mb-0"
                    style={{
                      fontSize: 'clamp(0.875rem, 2vw, 1rem)',
                      lineHeight: '1.6',
                      color: '#1a1a1a'
                    }}
                  >
                    Bit Happier doesn't stop at self-care, it rewards you! Attend Bit Happier events, participate in community-driven challenges, and build lasting habits that improve your mental, social, and financial well-being.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div style={{
        marginTop: '5rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingInline: '1rem',
        backgroundColor: '#ffe6eb',
        paddingTop: '4rem',
        paddingBottom: '4rem'
      }}>
        <div style={{
          display: 'flex',
          gap: '1rem',
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '2rem'
        }}>
          <h6 style={{
            borderRadius: '10000px',
            padding: '12px 24px',
            color: '#7c5a8f',
            backgroundColor: '#fff',
            border: 'none',
            fontSize: 'clamp(0.875rem, 2vw, 1rem)'
          }}>
            WHAT OUR CLIENTS THINK
          </h6>
        </div>
        <div className="row g-4" style={{ width: '100%', maxWidth: '1200px' }}>
          {/* Testimonial 1 - Beata Jirava */}
          <div className="col-12 col-lg-6">
            <div
              className="p-1 h-100"
              style={{
                backgroundColor: '#ffe6eb',
                borderRadius: '20px',
                overflow: 'hidden',
                maxWidth: '800px',
                margin: '0 auto'
              }}
            >
              <div className="p-4" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <p
                  className="mb-4 client-para"
                  style={{
                    fontSize: 'clamp(0.95rem, 2vw, 1.1rem)',
                    lineHeight: '1.7',
                    color: '#000',
                    fontWeight: '400',
                  }}
                >
                  "We are eager to observe the influence that Bit Happier will have on individuals worldwide. The team has combined cutting-edge technology, brain health information, and happiness data to provide personalized, data-driven recommendations. We anticipate the launch of the Bit Happier team and its potential to positively affect millions of people globally."
                </p>

                <div>
                  <div className="d-flex align-items-center mt-4">
                    <img
                      src={beata}
                      alt="Beata Jirava"
                      className="me-3"
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover'
                      }}
                    />
                  </div>

                  <p
                    className="mt-3 mb-0"
                    style={{
                      fontSize: 'clamp(0.875rem, 2vw, 0.95rem)',
                      color: '#666',
                      fontWeight: '400'
                    }}
                  >
                    - Beata Jirava
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Testimonial 2 - Rajnish Singh */}
          <div className="col-12 col-lg-6">
            <div
              className="p-1 h-100"
              style={{
                backgroundColor: '#ffe6eb',
                borderRadius: '20px',
                overflow: 'hidden',
                maxWidth: '800px',
                margin: '0 auto'
              }}
            >
              <div className="p-4" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <p
                  className="mb-4 client-para"
                  style={{
                    fontSize: 'clamp(0.95rem, 2vw, 1.1rem)',
                    lineHeight: '1.7',
                    color: '#000',
                    fontWeight: '400',
                  }}
                >
                  "Bit Happier is a Canadian neuroscience AI company focused on improving mental health through visual art. We are thrilled to work with their team and aim to bring happiness to millions of individuals and companies."
                </p>

                <div>
                  <div className="d-flex align-items-center mt-4">
                    <img
                      src={rajnish}
                      alt="Rajnish Singh"
                      className="me-3"
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover'
                      }}
                    />
                  </div>

                  <p
                    className="mt-3 mb-0"
                    style={{
                      fontSize: 'clamp(0.875rem, 2vw, 0.95rem)',
                      color: '#666',
                      fontWeight: '400'
                    }}
                  >
                    - Rajnish Singh
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        marginTop: '3rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingInline: '1rem',
        paddingBottom: '3rem',
        paddingTop: '3rem',
        gap: '2rem'
      }}
        className="cta-section">
        <div className="d-flex gap-3" style={{ width: '100%', flexDirection: 'column' }}>
          <div style={{ height: '50px' }}>
            <button className="science-tag">TAKE THE FIRST STEP</button>
          </div>
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            color: '#0e2a36',
            width: '100%',
            marginTop: '1rem'
          }}>
            Start Your Happiness Journey with Bit Happier
          </h1>
          <p style={{ fontSize: 'clamp(1rem, 2vw, 1.25rem)', width: '100%' }}>
            Join a growing community through our events. Whether it's workshops, talks, or social gatherings, every Bit Happier event leaves you feeling inspired and supported.
          </p>
          <p style={{ color: '#d9567a', fontWeight: 'bold', fontSize: 'clamp(1rem, 2vw, 1.25rem)' }}>
            Small steps, real impact.
          </p>
          <button
            className="hv2-btn hv2-btn-primary hv2-btn-md" style={{ maxWidth: 'fit-content', textWrap: 'auto' }}
            onClick={() => window.open('https://luma.com/ppp0sgi3')}
          >
            Reserve your place for the next event.
          </button>
          <div className="d-flex" style={{ width: '100%', marginTop: '2rem', borderRadius: '15px' }}>
            <img
              style={{ width: '100%', maxWidth: '600px', borderRadius: '15px', height: 'auto' }}
              src={lastSection}
              alt="Last Section"
            />
          </div>
        </div>
        <div className="d-flex" style={{ width: '100%', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
          <p style={{ fontSize: 'clamp(0.875rem, 2vw, 1rem)', textAlign: 'center', paddingInline: '1rem' }}>
            <a
              href="https://open.spotify.com/episode/2TAS7irKabRuU4MjfDNAev?si=5d56ba5de2f941fd&nd=1&dlsi=34ea4e32659649aa"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span style={{ color: '#d9567a' }}>Click Here</span>
            </a> to Listen to Our Conversation on Happiness with a Leading Canadian Doctor
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <img
              style={{
                width: '100%',
                maxWidth: '400px',
                height: 'auto',
                borderRadius: '15px'
              }}
              src={spotifyLink}
              alt="Spotify Link"
            />
          </div>
        </div>
      </div>

      {/* Social Media Section */}
      <div style={{
        marginTop: '3rem',
        display: 'flex',
        flexDirection: 'column',
        paddingInline: '1rem',
        paddingBottom: '1rem'
      }}>
        <div className="d-flex gap-3" style={{ flexDirection: 'column', alignItems: 'center' }}>
          <p style={{
            fontSize: 'clamp(1rem, 2vw, 1.25rem)',
            width: '100%',
            color: '#d9567a',
            fontWeight: 'bold',
            textAlign: 'center'
          }}>
            Find us on social platforms to stay a bit happier with us !
          </p>
          <div className="d-flex gap-0" style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
            {/* X (Twitter) */}
            <a
              href="https://x.com/bit_happier"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white d-flex align-items-center justify-content-center text-decoration-none"
              style={{
                backgroundColor: '#000000',
                width: '50px',
                height: '50px'
              }}
            >
              <FaXTwitter size={24} />
            </a>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/art-proven/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white d-flex align-items-center justify-content-center text-decoration-none"
              style={{
                backgroundColor: '#0077B5',
                width: '50px',
                height: '50px'
              }}
            >
              <FaLinkedinIn size={24} />
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/bithappier/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white d-flex align-items-center justify-content-center text-decoration-none"
              style={{
                backgroundColor: '#E4405F',
                width: '50px',
                height: '50px'
              }}
            >
              <FaInstagram size={24} />
            </a>

            {/* YouTube */}
            <a
              href="https://www.youtube.com/@bithappier"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white d-flex align-items-center justify-content-center text-decoration-none"
              style={{
                backgroundColor: '#FF0000',
                width: '50px',
                height: '50px'
              }}
            >
              <FaYoutube size={24} />
            </a>

            {/* TikTok */}
            <a
              href="https://www.tiktok.com/@bithappier"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white d-flex align-items-center justify-content-center text-decoration-none"
              style={{
                backgroundColor: '#000000',
                width: '50px',
                height: '50px'
              }}
            >
              <FaTiktok size={24} />
            </a>
          </div>
          <div style={{
            height: '50px',
            marginBottom: '1rem',
            marginTop: '1rem',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <img style={{ height: '40px' }} src={logo} alt="Logo" />
          </div>
        </div>
      </div>

      {/* Footer */}
      {/* <div style={{
        backgroundColor: '#000',
        width: '100%',
        color: '#fff',
        textAlign: 'center',
        padding: '12px',
        fontSize: 'clamp(0.75rem, 2vw, 1rem)'
      }}>
        Created By Monkhub Innovations Pvt. Ltd.
      </div> */}

      <style jsx>{`
        
      `}</style>
    </>
  )
}


export default MeetUp
